import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Group } from '../../../../models/group.model';
import { MembershipStatus } from '../../../../models/membership.status';
import { AppState } from '../../../../state/appstate';
import * as groupSelector from '../../../../state/selectors/group.selector';
import { BtnBackComponent } from '../../../components/buttons/btn-back/btn-back.component';
import { BtnWhatsappComponent } from '../../../components/buttons/btn-whatsapp/btn-whatsapp.component';
import { ListAlumniComponent } from '../list-alumni/list-alumni.component';
import { ListFacultyComponent } from '../list-faculty/list-faculty.component';
import { ListParentsComponent } from '../list-parents/list-parents.component';
import { ListStudentsComponent } from '../list-students/list-students.component';
import { ListUnassignedComponent } from '../list-unassigned/list-unassigned.component';

@Component({
  selector: 'app-list-members',
  standalone: true,
  imports: [
    AsyncPipe,
    BtnBackComponent,
    BtnWhatsappComponent,
    ListUnassignedComponent,
    ListStudentsComponent,
    ListParentsComponent,
    ListFacultyComponent,
    ListAlumniComponent,
  ],
  templateUrl: './list-members.component.html',
  styleUrl: './list-members.component.css',
})
export class ListSchoolMembersComponent implements OnInit, OnDestroy {
  store: Store<AppState> = inject(Store<AppState>);
  activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  @ViewChild(ListStudentsComponent)
  listStudentsComponent!: ListStudentsComponent;

  activeTab: string = 'faculty'; // Default active tab
  phoneNumber: string = '+1234567890';

  groupId: string | null = null;
  group$: Observable<Group | null | undefined> = new Observable();

  myRoles$: Observable<any> = new Observable();
  inviteText: string =
    'Join us on AtChurch. (https://web.atchurch.app/links/groupinvite?groupId=';

  membershipStatus = MembershipStatus;

  exit$: Subject<void> = new Subject<void>();

  constructor() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.groupId = params.get('id');
    });

    this.group$ = this.store.select(groupSelector.getSelectedGroup);

    this.myRoles$ = this.store.select(
      groupSelector.getMyRolesInGroup(this.groupId),
    );
  }

  ngOnDestroy(): void {
    this.exit$.next();
    this.exit$.complete();
  }

  ngOnInit() {
    this.store
      .select((state) => state.user.user)
      .pipe(takeUntil(this.exit$))
      .subscribe((user) => {
        if (user && user.contact && user.contact.contact) {
          this.phoneNumber = user.contact.contact;
        }
      });
    this.group$.pipe(takeUntil(this.exit$)).subscribe((group) => {
      this.inviteText = `Hi, I would like to invite you to join our school group '${group?.name}' on AtChurch. Please click on the link below to join. https://${environment.domain}/links/groupinvite?groupId=`;
    });
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
